<template>
    <div class="coupon-codes">
        <div class="codes">
            <div class="inputGroup">
                <label for="CDP_code">Discount/CDP/Club Code:</label>
                <input
                        v-model="cdpCode"
                        type="text"
                        name="cdp_code"
                        id="CDP_code"
                        placeholder="Discount/CDP/Club Code"
                        autocomplete="off"
                >
            </div>
            <div class="inputGroup">
                <label for="promo_coupon">Promotional Coupon (PC):</label>
                <input
                        v-model="promoCoupon"
                        type="text"
                        name="promo_coupon"
                        id="promo_coupon"
                        placeholder="Promotional Coupon (PC)"
                        autocomplete="off"
                >
            </div>
            <div class="inputGroup">
                <label for="rate_code">Rate Code (RQ):</label>
                <input
                        v-model="rateCode"
                        type="text" name="rate_code"
                        id="rate_code"
                        placeholder="Rate Code (RQ)"
                        autocomplete="off"
                >
            </div>
            <div class="inputGroup">
                <label for="voucher_number">Voucher Number (IT):</label>
                <input
                        v-model="voucherNumber"
                        type="text"
                        name="voucher_number"
                        id="voucher_number"
                        placeholder="Voucher Number (IT)"
                        autocomplete="off"
                >
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>

    .coupon-codes {
        border: 2px dotted red;
    }
</style>


<script>
    const Api = require('../../../../global/js/modules/api');

    const events = {};


    export default {
        components: {},
        props: {
            cdpCode: {
                type: String,
                required: false,
                default: '',
            },
            promoCoupon: {
                type: String,
                required: false,
                default: '',
            },
            rateCode: {
                type: String,
                required: false,
                default: '',
            },
            voucherNumber: {
                type: String,
                required: false,
                default: '',
            },
        },
        data: () => {
            return {}
        },
        computed: {},
        mounted() {
        },
        methods: {}
    }
</script>
